import { motion } from 'framer-motion';
import { UserCheck, Target, TrendingDown } from 'lucide-react';

/* ═══════════════════════════════════════════
   EDITABLE: Process steps
   - Edit title, description, icon for each step
═══════════════════════════════════════════ */
const steps = [
  {
    icon: UserCheck,
    title: 'Understanding Your Financial Profile',
    description: 'We start by analyzing your net worth and categorizing your assets and liabilities. This foundational step ensures a personalized strategy aligned with your financial reality.',
  },
  {
    icon: Target,
    title: 'Goal-Based Planning & Asset Allocation',
    description: 'With a clear picture of your financial standing, we map your short- and long-term goals and allocate assets accordingly — considering risk tolerance, cash flow needs, and investment horizon.',
  },
  {
    icon: TrendingDown,
    title: 'SWP (Systematic Withdrawal Plan)',
    description: 'For post-retirement planning, we design SWPs that provide steady income. We factor in inflation, lifestyle costs, and economic changes — ensuring your wealth continues to support your lifestyle.',
  },
];

export const ProcessSection = () => {
  return (
    <section data-testid="process-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        {/* Banner */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="bg-[#0A192F] rounded-2xl p-10 md:p-14 text-center mb-16"
        >
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-white mb-4">
            Plan Better. Invest Smarter.
          </h2>
          <a
            href="#contact"
            data-testid="process-cta-btn"
            className="inline-block px-8 py-3 bg-[#D4AF37] text-[#0A192F] font-semibold rounded-full hover:bg-[#C5A059] hover:scale-105 transition-all duration-300"
          >
            Discover More
          </a>
        </motion.div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              data-testid={`process-step-${index}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="relative"
            >
              {/* Step Number */}
              <div className="absolute -top-3 -left-2 w-8 h-8 bg-[#D4AF37] rounded-full flex items-center justify-center text-[#0A192F] text-sm font-bold">
                {index + 1}
              </div>
              <div className="bg-[#F8F9FA] rounded-xl p-8 pt-10 h-full">
                <step.icon size={28} className="text-[#D4AF37] mb-4" />
                <h3 className="font-['Playfair_Display'] text-lg font-bold text-[#0A192F] mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-[#49566B] leading-relaxed font-['Outfit']">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
